import React, { useEffect } from "react";
// import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import { Button, TextField, Link } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ToretaApi from "../../ToretaApi";
import Dialog from "./Dialog";
// import { ReservationFilter } from "../../common/interface";
import AutocompleteField from "../../Components/AutocompleteField";
import countries from "../../common/Const/countries";
import { CompanyBody, CompanyFilter } from "../../common/interface";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
        },
        container: {
            maxHeight: window.innerHeight - 280,
            [theme.breakpoints.down("md")]: {
                maxHeight: window.innerHeight - 280,
            },
        },
    })
);
type Props = {};
interface CompanySearch {
    name: string;
    country: string;
}
interface CompanyList {
    rows?: CompanyBody[];
    count: number;
}
const StickyTable: React.FunctionComponent<Props> = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [pageData, setPageData] = React.useState<CompanyList | null>(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const [filter, setFilter] = React.useState<CompanySearch>({
        name: "",
        country: "",
    });
    const [dialogStatus, setDialogStatus] = React.useState<any>({ open: false, data: null });
    const dialogClose = () => {
        setDialogStatus({ open: false, data: null });
    };
    const dialogOpen = (data: CompanyBody | null) => {
        setDialogStatus({ open: true, data: { ...data } });
    };
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const toretaApi = ToretaApi();
    const clickButton = () => {
        if (page === 0) {
            search();
        } else {
            setPage(0);
        }
    };
    const updateRestaurants = (companyId: number | undefined, name: string) => {
        if (!companyId) {
            return;
        }
        Swal.fire({
            title: t("MANAGER.CONFIRM.COMAPNY_RESTAURANTS_UPDATE", { name }),
            // text: "You won't be able to revert this!",
            showDenyButton: true,
            icon: "warning",
            confirmButtonText: t("MANAGER.STATUS.YES"),
            denyButtonText: t("MANAGER.STATUS.NO"),
        }).then((result: any) => {
            if (result.isConfirmed) {
                toretaApi.updateRestaurantsWithCompanyAPIToken(companyId).then(search);
            }
        });
    };
    const search = React.useCallback(() => {
        const sendFilter: CompanyFilter = {
            ...filter,
            page: page,
            perPage: rowsPerPage,
        };
        toretaApi.getCompanyPage(sendFilter).then(setPageData);
        // eslint-disable-next-line
    }, [page, rowsPerPage, filter]);
    const getImageUrl = (company: CompanyBody) => {
        if (!company.picture) {
            return "";
        }

        if (company.picture.startsWith("http")) {
            return company.picture;
        } else {
            return `https://reserve.toretaasia.com${company.picture}`;
        }
    };
    // useEffect(() => {
    //     setCompanyId(user.companyId);
    // }, []);
    useEffect(() => {
        search();
        // eslint-disable-next-line
    }, [page, rowsPerPage]);

    return (
        <>
            <Dialog open={dialogStatus.open} data={dialogStatus.data} close={dialogClose} search={search} />
            <Grid item xs={3}>
                <TextField
                    label={t("MANAGER.FIELD.COMPANY")}
                    type="text"
                    value={filter.name}
                    fullWidth
                    onChange={(event) => {
                        setFilter({ ...filter, name: event.target.value });
                    }}
                />
            </Grid>
            <Grid item xs={3}>
                <AutocompleteField
                    label={t("MANAGER.FIELD.COUNTRY")}
                    variant={"standard"}
                    optionList={countries}
                    value={filter.country}
                    onChange={(value: any) => {
                        setFilter({ ...filter, country: value });
                    }}
                />
            </Grid>
            <Grid item xs={3}>
                <Button variant="contained" color="primary" onClick={clickButton}>
                    {t("MANAGER.ACTION.SEARCH")}
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                        dialogOpen({
                            name: "",
                            currency: null,
                            country: null,
                            picture: null,
                            publicApiToken: null,
                            file: null,
                        })
                    }
                >
                    {t("MANAGER.ACTION.ADD")}
                </Button>
            </Grid>
            {pageData && pageData.rows ? (
                <Grid item xs={12}>
                    <Paper className={classes.root}>
                        <TableContainer className={classes.container}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t("MANAGER.FIELD.COMPANY")}</TableCell>
                                        <TableCell>{t("MANAGER.FIELD.TORETA_API_TOKEN")}</TableCell>
                                        <TableCell>{t("MANAGER.FIELD.CURRENCY")}</TableCell>
                                        <TableCell>{t("MANAGER.FIELD.COUNTRY")}</TableCell>
                                        <TableCell>{t("MANAGER.FIELD.PIC")}</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pageData.rows.map((row: CompanyBody) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                <TableCell>{row.name}</TableCell>
                                                <TableCell>{row.publicApiToken && row.publicApiToken.slice(-10)}</TableCell>
                                                <TableCell>{row.currency}</TableCell>
                                                <TableCell>{countries.find((a) => a.value === row.country)?.label}</TableCell>
                                                <TableCell>
                                                    <Link rel="noopener" target="_blank" href={getImageUrl(row)}>
                                                        {t("MANAGER.FIELD.LINK")}
                                                    </Link>
                                                </TableCell>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            dialogOpen(row);
                                                        }}
                                                    >
                                                        {t("MANAGER.ACTION.EDIT")}
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            updateRestaurants(row.id, row.name);
                                                        }}
                                                    >
                                                        {t("MANAGER.ACTION.UPDATE_RESTAURANTS")}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 50]}
                            component="div"
                            count={pageData.count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => {
                                return t("MANAGER.TABLE.CURRENT", {
                                    from,
                                    to,
                                    count,
                                });
                            }}
                            labelRowsPerPage={t("MANAGER.TABLE.PERPAGE")}
                            backIconButtonText={t("MANAGER.TABLE.PER_PAGE")}
                            nextIconButtonText={t("MANAGER.TABLE.NEXT_PAGE")}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Grid>
            ) : (
                <></>
            )}
        </>
    );
};
export default StickyTable;
